export default __webpack_public_path__ + "static/media/broomfield-openspaces.d4e3ad09.ttf";